import { render, staticRenderFns } from "./AdminDashBoard.vue?vue&type=template&id=da30ce0e&scoped=true&lang=pug"
import script from "./AdminDashBoard.vue?vue&type=script&lang=js"
export * from "./AdminDashBoard.vue?vue&type=script&lang=js"
import style0 from "./AdminDashBoard.vue?vue&type=style&index=0&id=da30ce0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da30ce0e",
  null
  
)

export default component.exports